<script setup lang="ts">
import {computed, onMounted, ref, watch} from 'vue'

  const iframeRef = ref<HTMLIFrameElement | null>(null)
  const iFrameContainerRef = ref<HTMLIFrameElement | null>(null)

  const props = withDefaults(defineProps<{
    id: string
    src: string
    title?: string
    width?: string
    height?: string
    border?: string
    borderRadius?: string
    scrolling?: string
    overflow?: string

    layout?: string
    triggerType?: string
    triggerValue?: string
    activationType?: string
    activationValue?: string
    deactivationType?: string
    deactivationValue?: string
    formName?: string
    dataSetHeight?: string
    layoutIframeId?: string
    formId?: string
  }>(), {
    width: '100%',
    height: '0px',
    border: 'none',
    borderRadius: '0px'
  })

  /* ---------- styles ---------- */

  const iframeStyle = computed(() => ({
    width: props.width,
    height: props.dataSetHeight,
    border: props.border,
    borderRadius: props.borderRadius
  }))

  /* ---------- data-* attributes ---------- */

  const dataAttributes = computed(() => ({
    'data-layout': props.layout,
    'data-trigger-type': props.triggerType,
    'data-trigger-value': props.triggerValue,
    'data-activation-type': props.activationType,
    'data-activation-value': props.activationValue,
    'data-deactivation-type': props.deactivationType,
    'data-deactivation-value': props.deactivationValue,
    'data-form-name': props.formName,
    'data-height': props.dataSetHeight,
    'data-layout-iframe-id': props.layoutIframeId,
    'data-form-id': props.formId
  }))

  watch(iFrameContainerRef, () => {
    if (!iFrameContainerRef.value) {
      return;
    }

    const el = (iFrameContainerRef.value as HTMLElement)

    if (el.querySelector('script[src*="nexor"]')) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://link.nexor.digital/js/form_embed.js';

    el.appendChild(script)
  })
</script>
<template>
    <div ref="iFrameContainerRef">
      <iframe
        ref="iframeRef"
        :id="id"
        :title="title"
        :src="src"
        :style="iframeStyle"
        v-bind="dataAttributes"
        loading="lazy"
        :height="props.dataSetHeight"
      />
    </div>
</template>
